<div
  (keyup.space)="!disabled && this.toggle.emit(); $event.preventDefault()"
  (keydown.enter)="!disabled && this.toggle.emit(); $event.preventDefault()"
  [class]="'switch' + (extraClasses ? ' ' + extraClasses : '') + (disabled ? ' switch--disabled' : '')"
  [class.small]="small"
  (click)="!disabled && this.toggle.emit()"
  [tabindex]="disabled ? -1 : 0"
  role="switch"
  [attr.aria-checked]="active"
  [attr.aria-disabled]="disabled"
  [attr.aria-label]="label || 'Toggle switch'"
  [style.opacity]="disabled ? '0.4' : '1'"
  [style.pointer-events]="disabled ? 'none' : 'auto'"
>
  @if (label && !labelToRight) {
    <div class="switch__label" id="switch-label">{{ label }}</div>
  }
  <div class="switch__track" data-cy="myp-switch" [style.backgroundColor]="active ? activeTrackColor : '#999'" aria-hidden="true">
    <div class="switch__handle" [class.active]="active"></div>
  </div>
  @if (label && labelToRight) {
    <div class="switch__label m-l-10" id="switch-label-right">
      {{ label }}
      @if (sublabel) {
        <br />
        <span class="t-12 text-muted">{{ sublabel }}</span>
      }
    </div>
  }
</div>
